import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonWoman = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M22 27H25",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.796 21.907L10.971 25.417C10.369 25.779 10 26.43 10 27.132V31H30V27.132C30 26.429 29.631 25.778 29.029 25.417L23.204 21.907",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.999 15.106C24.039 15.106 22.256 14.298 20.985 13C19.714 14.298 17.945 15.106 15.985 15.106C15.295 15.106 14.633 14.982 14.003 14.796",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 15C14 11.686 16.686 9 20 9C23.314 9 26 11.686 26 15C26 20 23.314 23 20 23C16.686 23 14 20 14 15Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 15C14 15 14 19 10 22C10.844 24.057 12.751 24.345 12.751 24.345",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M25.938 15C25.938 15 25.938 19 29.938 22C29.094 24.057 27.187 24.345 27.187 24.345",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		})
	]
});
const ForwardRef = forwardRef(SvgPersonWoman);
export default ForwardRef;
